import { createSelector } from 'reselect';
import { createSelectorDeep } from 'reselects/misc';

import { mapShipperOrdersForComputedProperties } from 'redux/modules/shipper-orders/selectors';

export const getState = (state) => state.shipperOrderDetail;

export const getCostQuote = createSelectorDeep(getState, (state) => state.costQuote);
export const getShipperOrderDetail = createSelectorDeep(getState, (detail) => detail);
export const getShipperOrderDetailData = createSelectorDeep(
  getShipperOrderDetail,
  (detail) => detail?.data && mapShipperOrdersForComputedProperties(detail.data)
);
export const getShipperOrderDetailError = createSelectorDeep(getState, (detail) => detail.error);

export const submodalOpened = createSelector(getState, (state) => state.submodal.name);
